import { Breakpoint, Typography } from '@altibox/design-system-component-lib';
// eslint-disable-next-line import/no-unresolved
import { TypographyProps } from '@altibox/design-system-component-lib/dist/components/typography/types';
import React, { FC } from 'react';

type Props = Omit<TypographyProps, 'component'>;

export const BulletListElement: FC<Props> = (props) => {
  const { maxBreakpoint = Breakpoint.TABLET } = props;

  return <Typography {...props} component="li" maxBreakpoint={maxBreakpoint} />;
};
